import {
  getAppLocation,
  getCookie,
  getOTAP,
  getPathname,
  LoginPage,
  SettingsContext,
  SigninOidc
} from "adviesbox-shared";
import React, { ReactElement, useContext } from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { RouteParams } from "../shared/paramrouting/paramrouting-context";
import logo from "../assets/new-brand-logo.svg";

const UnauthenticatedInstellingenApp = (): ReactElement => {
  const { baseUrls } = useContext(SettingsContext);
  const linkToPortal = getAppLocation(window.location.origin, "INS", "POR", baseUrls);
  const vestigingIdCookie = getCookie(`${getOTAP(window.location.hostname)}_vestigingid`);

  return (
    <>
      <Route
        exact
        path={"/vestiging/:vestiging"}
        render={({ history }: RouteComponentProps<RouteParams>) => {
          const base = getPathname().charAt(getPathname().length - 1);
          if (base === "/") {
            history.push(`${getPathname()}autorisatieniveau`);
            return <></>;
          }
          history.push(`${getPathname()}/autorisatieniveau`);
          return <></>;
        }}
      />
      <Route
        exact
        path={"/"}
        render={({ history }: RouteComponentProps) => {
          if (!vestigingIdCookie) {
            window.location.assign(linkToPortal);
            return <></>;
          }

          history.push(`/vestiging/${vestigingIdCookie}/autorisatieniveau`);
          return <></>;
        }}
      />
      <Route path="/signin-oidc" component={SigninOidc} />
      <LoginPage appLogo={logo} />
    </>
  );
};

UnauthenticatedInstellingenApp.displayName = "InstellingenApp";

export default UnauthenticatedInstellingenApp;
